import React from 'react'
// libs
import styled from 'styled-components'
// icons
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
// utils
import isUndefined from 'lodash/fp/isUndefined'

const CloseIcon = styled((props) => <CloseRoundedIcon {...props} />)`
  && {
    cursor: pointer;
    position: absolute;
    right: ${({ right }) => (isUndefined(right) ? '20px' : right)};
    top: 50%;
    transform: translateY(-50%);
  }
`

export default CloseIcon
